import React, { useContext } from 'react';
import FormTarea from './FormTarea';
import BotonesForm from './BotonesForm';
import proyectoContext from '../../context/proyectos/proyectoContext';

const FormularioPrincipal = () => {

    // Extraer si una vista de un proyecto fue seleccionada
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, proyectoactivo } = proyectosContext;

    // Si no hay proyecto seleccionado
    if(!proyecto || !proyectoactivo) return null;

    return ( 
        <div className="formulario">
            <FormTarea />
            <BotonesForm />
        </div>
    );
}
 
export default FormularioPrincipal;